module.exports = __webpack_public_path__ + "img/symbol_10.f08f627e.png";